import { TRIGGER_SEND_REFERRALS_API_CALL, TRIGGER_SEND_REFERRALS_API_CALL_SUCCESS } from 'redux/actionTypes';

export function triggerSendReferralsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_SEND_REFERRALS_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerSendReferralsApiCallSuccess(data) {
	return {
		type: TRIGGER_SEND_REFERRALS_API_CALL_SUCCESS,
		data,
	};
}
